import { ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons';
import { Box, Button, Card, Grid, Popover } from '@radix-ui/themes';
import { CommonInputLabel } from 'components/common/form/label';
import { CommonSelectInput } from 'components/common/form/select';
import { CommonSwitchInput } from 'components/common/form/switch';
import { CookieKey } from 'enums/cookies.enums';
import { t } from 'i18next';
import {
  BUILD_PRIORITY_OPTIONS,
  BuildPriority,
} from 'lib_ts/enums/pitches.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useState } from 'react';
import { useCookiesStore } from 'stores/use-cookies-store';

export const ImportSettingsPopover = () => {
  const app = useCookiesStore((s) => s.app);

  const [openSettings, setOpenSettings] = useState(false);

  return (
    <Popover.Root onOpenChange={(open) => setOpenSettings(open)}>
      <Popover.Trigger>
        <Button variant={RADIX.BUTTON.VARIANT.SECONDARY}>
          {t('common.settings')}
          {openSettings ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </Button>
      </Popover.Trigger>
      <Popover.Content asChild>
        <Card>
          <Grid width="300px" gap="3" columns="3" align="center" p="1">
            <Box gridColumn="span 2">
              <CommonInputLabel label="common.import-method" />
            </Box>
            <Box>
              <CommonSelectInput
                id="pitches-header-build-priority"
                options={BUILD_PRIORITY_OPTIONS}
                value={app.game_data_import_options.priority}
                onChange={(v) =>
                  useCookiesStore.getState().setCookie(CookieKey.app, {
                    game_data_import_options: {
                      ...app.game_data_import_options,
                      priority: v as BuildPriority,
                    },
                  })
                }
              />
            </Box>

            <Box gridColumn="span 2">
              <CommonInputLabel
                label="common.normalize-releases"
                labelJustify="start"
                iconTooltip="All pitches by the same pitcher will share an average release position."
              />
            </Box>
            <Box>
              <CommonSwitchInput
                id="pitches-header-normalize"
                defaultChecked={app.game_data_import_options.average_release}
                onCheckedChange={(v) =>
                  useCookiesStore.getState().setCookie(CookieKey.app, {
                    game_data_import_options: {
                      ...app.game_data_import_options,
                      average_release: v,
                    },
                  })
                }
              />
            </Box>
          </Grid>
        </Card>
      </Popover.Content>
    </Popover.Root>
  );
};
